import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Form, Errors, actions} from 'react-redux-form'
import {Row, Col} from 'react-bootstrap'
import LayoutContainer from "../../../layout/layout-container/index";
import ErrorMessages from '../../login/error-messages'
import ArrowButton from '../../../common/button-arrow'
import {convertPoints, savePpcManualLoad} from '../../../../actions/ppc'
import RequiredInput from '../../../common/form/elements/required-input';
import {isRrfFormValid} from '../../../../utils/commonFunctions'

class PpcLoadForm extends Component {

  constructor(props) {
    super(props);
  }

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.admin_ppc.management.manual_load', savePpcManualLoad(this.props.userId, payLoad)));
  };

  convertPointsToEuros = (points) => {
    const {dispatch} = this.props;
    dispatch(convertPoints(points, this.props.links["convert-to-value"], 'deep.admin_ppc.management.manual_load.value'));
  };

  render() {
    return (
      <LayoutContainer>
        <Form model="deep.admin_ppc.management.manual_load"
              onSubmit={this.onSubmit}>
          <Errors className="errors" model="deep.admin_ppc.management.manual_load" component={ErrorMessages}/>
          <Row>
            <Col lg={12}>
              <RequiredInput model=".points"
                             placeholder="e.g. 200"
                             label="Load value (points)"
                             debounce={200}
                             onChange={this.convertPointsToEuros}
                             controlId="loadPoints"/>

              <RequiredInput model=".value"
                             placeholder="e.g. 20"
                             label="Load value (€)"
                             controlId="loadValue"
                             readOnly/>
            </Col>

          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton className="pull-right"
                           disabled={this.props.form.$form.pending || !isRrfFormValid(this.props.form, {async: false})}>Place order</ArrowButton>
            </Col>
          </Row>
        </Form>
      </LayoutContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    form: state.deep.forms.admin_ppc.management.manual_load,
    links: state.ppc.loadLinks
  };
};

export default connect(mapStateToProps)(PpcLoadForm);


// WEBPACK FOOTER //
// ./src/components/admin/ppc/load-manual/ppc-load-form.jsx